<template>
    <div>
        <nl-loader v-show="preloading" :show="true" />

        <div v-show="!preloading">
            <div>
                <b-loading v-model="isLoading" :is-full-page="true" />

                <section class="box">
                    <!--                    <ExportSite />-->
                    <b-tabs
                        v-model="activeTab"
                        @input="
                            value => {
                                openOnce[value] = true
                            }
                        "
                    >
                        <b-tab-item
                            v-for="(tab, key) in tabs"
                            :key="`sites_${key}`"
                            :label="`${tab.label} (${counts[tab.type] || 0})`"
                            :icon="tab.icon"
                            :value="tab.type"
                            :disabled="counts[tab.type] <= 0"
                        >
                            <GroupSiteTable
                                v-if="openOnce[key]"
                                :force-update="forceUpdate"
                                :left-buttons="leftButtons"
                                :tab-info="tab"
                                :groups="groups"
                                :status="tab.status"
                                @deleteBulkSites="deleteBulkSites"
                                @desactivateBulkSites="desactivateBulkSites"
                                @activateBulkSites="activateBulkSites"
                                @waitingActivateBulkSites="waitingActivateBulkSites"
                                @redactionBulkSites="redactionBulkSites"
                                @typeBulkSites="typeBulkSites"
                                @groupBulkSites="groupBulkSites"
                            />
                        </b-tab-item>
                    </b-tabs>
                </section>
            </div>
        </div>

        <GroupSiteModal ref="siteModal" :groups="groups" @saveSite="saveSite" />
        <SiteExportModal ref="siteExportModal" />
    </div>
</template>

<script>
    import GroupSiteModal from '@/components/Admin/Sites/GroupSiteModal'
    import SiteExportModal from '@/components/Admin/Orders/SiteExportModal.vue'
    import GroupSiteTable from '@/components/Admin/Sites/GroupSiteTable.vue'
    import { mapActions } from 'vuex'

    export default {
        name: 'GroupsSites',
        title: 'group-site.title',
        components: {
            GroupSiteTable,
            // ExportSite,
            GroupSiteModal,
            SiteExportModal
        },
        data() {
            return {
                wordpress_url_plugin: '',
                sites: [],
                groups: [],
                // Tabs
                activeTab: 0,
                // Total per tabs
                counts: {},
                // Store witch tab has been open
                openOnce: {
                    0: true
                },
                // Force table to refresh data
                forceUpdate: false,

                // Table top-left buttons
                leftButtons: [
                    {
                        label: this.$t('partenaire-site.addawebsite'),
                        icon: 'plus-circle',
                        type: 'is-secondary',
                        action: () => this.openModal()
                    },
                    {
                        label: this.$t('partenaire-site.download_wp_plugin'),
                        icon: 'wordpress',
                        iconPack: 'fab',
                        type: 'is-info',
                        action: () => window.open(this.wordpress_url_plugin, '_blank')
                    },
                    {
                        label: "Export des sites",
                        icon: 'file-download',
                        iconPack: 'fas',
                        type: 'is-warning',
                        action: () => this.openCsvSiteModal()
                    },
                    {
                        label: '',
                        icon: 'sync-alt',
                        type: 'is-dark',
                        action: () => (this.forceUpdate = !this.forceUpdate)
                    }
                ],
                activedSites: [],
                deletedSites: [],
                waitingActivationSites: [],
                desactivatedNLSites: [],
                desactivatedSites: [],
                waitingImprovementSites: [],
                preloading: true,
                isLoading: false,
                statusActive: 1,
                statusDelete: 0,
                statusWaitingActivation: -1,
                statusDesactiveNL: -2,
                statusRefuse: -3,
                statusDesactivePartner: -4,
                statusWaitingImprove: -5
            }
        },

        created() {
            // this.getData()
            this.getConfigByName({ name: 'url_download_wordpress_plugin' }).then(data => {
                this.wordpress_url_plugin = data
            })
            this.getCounts().then(() => {
                this.preloading = false
            })
            this.getTranslatedGroups().then(data => {
                this.groups = data.groups
            })
        },

        computed: {
            tabs() {
                return [
                    {
                        type: 'all',
                        label: this.$t('global.all'),
                        icon: 'sitemap',
                        status: null
                    },
                    {
                        type: 'waiting_activation',
                        label: this.$t('status.attentevalidation'),
                        icon: 'pause-circle',
                        status: -1
                    },
                    {
                        type: 'waiting_improvement',
                        label: this.$t('partenaire-site.attenteamelioration'),
                        icon: 'briefcase',
                        status: -5
                    },
                    {
                        type: 'activated',
                        label: this.$t('status.activated-s'),
                        icon: 'check-circle',
                        status: 1
                    },
                    {
                        type: 'desactivated_nl',
                        label: 'Inactif admin',
                        icon: 'power-off',
                        status: -2
                    },
                    {
                        type: 'desactivated',
                        label: this.$t('global.inactive'),
                        icon: 'power-off',
                        status: -4
                    },
                    {
                        type: 'deleted',
                        label: this.$t('status.supressed-s'),
                        icon: 'trash-alt',
                        status: 0
                    }
                ]
            }
        },

        methods: {
            ...mapActions('config', ['getConfigByName']),
            ...mapActions('sites', ['getSitesCount']),
            ...mapActions('group', ['getTranslatedGroups']),

            async getCounts() {
                let total = 0
                const counts = await this.getSitesCount()
                counts.forEach(count => {
                    total += count.total
                    if (count.actif === -3) return
                    const tabItem = this.tabs.find(tab => tab.status === count.actif)

                    this.$set(this.counts, tabItem.type, count.total)
                })

                this.$set(this.counts, 'all', total)
            },

            saveSite(formData) {
                this.isLoading = true

                let form = new FormData()
                for (const [key, value] of Object.entries(formData)) {
                    if (value == null) {
                        form.append(key, '')
                    } else {
                        form.append(key, value)
                    }
                }

                this.axios
                    .post(`/admin/sites/create`, form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        this.snackNotif(this.$t('group-site.valid-save-site'))
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-danger')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            reloadTabs() {
                this.openOnce = { [this.activeTab]: true }
                this.forceUpdate = !this.forceUpdate
                this.getCounts()
            },

            deleteBulkSites(params) {
                this.isLoading = true

                this.axios
                    .delete(`/admin/sites/bulk-delete`, {
                        data: {
                            notes: params.notes,
                            ids: JSON.stringify(params.ids)
                        }
                    })
                    .then(() => {
                        this.snackNotif(this.$t('partenaire-site.valid-delete-site'))
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-danger')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            desactivateBulkSites(params) {
                this.isLoading = true

                this.axios
                    .patch(`/admin/sites/bulk-desactivate`, {
                        ids: JSON.stringify(params.ids),
                        choice_type: params.choice_type,
                        scheduled_at: params.scheduled_at,
                        desactivation_site_to: params.desactivation_site_to,
                        notes: params.notes
                    })
                    .then(() => {
                        this.snackNotif(this.$t('partenaire-site.valid-desactive-site'))
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-danger')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            activateBulkSites(params) {
                this.isLoading = true

                this.axios
                    .patch('/admin/sites/bulk-activate', {
                        ids: JSON.stringify(params.ids)
                    })
                    .then(() => {
                        this.snackNotif(this.$t('group-site.valid-active-sites'))
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-danger')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            waitingActivateBulkSites(params) {
                this.isLoading = true

                this.axios
                    .patch(`/admin/sites/bulk-waiting-activate`, {
                        ids: JSON.stringify(params.ids),
                        choice_type: params.choice_type,
                        notes: params.notes
                    })
                    .then(() => {
                        this.snackNotif("Le site est maintenant en attente d'amélioration")
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-danger')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            redactionBulkSites(params) {
                this.isLoading = true

                this.axios
                    .patch(`/admin/sites/redaction`, {
                        ids: JSON.stringify(params.ids),
                        redaction: params.redaction
                    })
                    .then(() => {
                        this.snackNotif(this.$t('partenaire-site.valid-edit-sites'))
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-error')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            typeBulkSites(params) {
                this.isLoading = true

                this.axios
                    .patch(`/admin/sites/type`, {
                        ids: JSON.stringify(params.ids),
                        type: params.type
                    })
                    .then(() => {
                        this.snackNotif(this.$t('partenaire-site.valid-edit-sites'))
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-error')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            groupBulkSites(params) {
                this.isLoading = true

                this.axios
                    .patch(`/admin/sites/group`, {
                        ids: JSON.stringify(params.ids),
                        group: params.group
                    })
                    .then(() => {
                        this.snackNotif(this.$t('partenaire-site.valid-edit-sites'))
                    })
                    .catch(error => {
                        this.snackNotif(error.response.data.message, 'is-error')
                    })
                    .finally(() => {
                        this.reloadTabs()
                        this.isLoading = false
                    })
            },

            formatTabs() {
                this.tabs = []
            },

            openModal() {
                this.$refs.siteModal.openModal()
            },

            openCsvSiteModal()
            {
                this.$refs.siteExportModal.open()
            },
        }
    }
</script>